import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ExportPanel = ({ data, selectedRange }) => {
  const [exportFormat, setExportFormat] = useState('csv');
  const [showSuccess, setShowSuccess] = useState(false);

  const handleExport = () => {
    let content = '';
    const filename = `stablecoin-m2-historical-${selectedRange}-${new Date()?.toISOString()?.split('T')?.[0]}`;

    if (exportFormat === 'csv') {
      content = 'Date,Ratio (%),Change (%)\n';
      data?.forEach(item => {
        content += `${item?.date},${item?.ratio?.toFixed(4)},${(item?.change || 0)?.toFixed(2)}\n`;
      });
    } else if (exportFormat === 'json') {
      content = JSON.stringify(data, null, 2);
    }

    const blob = new Blob([content], { type: exportFormat === 'csv' ? 'text/csv' : 'application/json' });
    const url = window.URL?.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${filename}.${exportFormat}`;
    document.body?.appendChild(a);
    a?.click();
    document.body?.removeChild(a);
    window.URL?.revokeObjectURL(url);

    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 3000);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6">
      <h3 className="text-base md:text-lg font-semibold text-foreground mb-4">
        Export Historical Data
      </h3>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Export Format
          </label>
          <div className="flex gap-2">
            <Button
              variant={exportFormat === 'csv' ? 'default' : 'outline'}
              size="sm"
              onClick={() => setExportFormat('csv')}
              iconName="FileText"
              iconPosition="left"
            >
              CSV
            </Button>
            <Button
              variant={exportFormat === 'json' ? 'default' : 'outline'}
              size="sm"
              onClick={() => setExportFormat('json')}
              iconName="Code"
              iconPosition="left"
            >
              JSON
            </Button>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-2">
          <Button
            variant="default"
            onClick={handleExport}
            iconName="Download"
            iconPosition="left"
            className="flex-1"
          >
            Export Data
          </Button>
          <Button
            variant="outline"
            iconName="Share2"
            iconPosition="left"
            className="flex-1"
          >
            Share
          </Button>
        </div>

        {showSuccess && (
          <div className="flex items-center gap-2 p-3 bg-success/10 border border-success/20 rounded text-success text-sm">
            <Icon name="CheckCircle" size={16} color="currentColor" />
            <span>Data exported successfully!</span>
          </div>
        )}

        <div className="text-xs text-muted-foreground">
          <p>Data points: {data?.length}</p>
          <p>Period: {selectedRange}</p>
          <p>Last updated: {new Date()?.toLocaleDateString()}</p>
        </div>
      </div>
    </div>
  );
};

export default ExportPanel;